<template>
  <div>
    <div class="admin-form">
      <div class="form-container">
        <form-title
          v-bind:formTitleText="formTitleText"
          v-bind:formSubtext="formSubtext"
        />
        <form v-on:submit="handleSubmit">
          <div v-bind:key="field.name" v-for="field in formFields">
            <div class="form-field">
              <!-- 1. Bind type reactively using field.type -->
              <input
                v-bind:class="{ errorClass: defErrors[field.errorName] }"
                v-bind:id="field.name"
                v-bind:name="field.name"
                v-bind:placeholder="field.placeholder"
                v-bind:type="field.type"
                v-on:change="validateInputs($event, field.name)"
              />
              <!-- <svg
                v-if="field.name === 'password'"
                class="password-eye"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                @click="showPassword(field)"
              >
                <g id="eye_mini">
                  <g id="Union">
                    <path
                      d="M8 10C9.10457 10 10 9.10459 10 8.00002C10 6.89546 9.10457 6.00002 8 6.00002C6.89543 6.00002 6 6.89546 6 8.00002C6 9.10459 6.89543 10 8 10Z"
                      fill="#626C83"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M0.531404 8.47233C0.413913 8.16701 0.414015 7.82853 0.531688 7.52329C1.68702 4.52633 4.59464 2.40002 7.99887 2.40002C11.4048 2.40002 14.3136 4.52843 15.4678 7.52772C15.5853 7.83304 15.5852 8.17152 15.4675 8.47677C14.3121 11.4737 11.4045 13.6 8.0003 13.6C4.59438 13.6 1.68558 11.4716 0.531404 8.47233ZM11.2003 8.00002C11.2003 9.76734 9.76761 11.2 8.0003 11.2C6.23299 11.2 4.8003 9.76734 4.8003 8.00002C4.8003 6.23271 6.23299 4.80002 8.0003 4.80002C9.76761 4.80002 11.2003 6.23271 11.2003 8.00002Z"
                      fill="#626C83"
                    />
                  </g>
                </g>
              </svg> -->
              <div class="errorBlock" v-if="defErrors[field.errorName]">
                <p>
                  <em class="errorExist">
                    {{ field.placeholder }} is Invalid.
                  </em>
                </p>
              </div>
            </div>
          </div>
          <div>
            <div class="errorBlock">
              <!-- <p>
                <em class="errorExist" v-if="errorExists">
                  Highlighted field is Invalid.
                </em>
              </p> -->
              <p>
                <em class="passwordHintText">
                  {{ hintText }}
                </em>
              </p>
            </div>
            <div class="baselink-container">
              <router-link v-bind:to="baseLink.link">{{
                baseLink.text
              }}</router-link>
            </div>
          </div>
          <div class="button-container">
            <button
              type="submit"
              class="submit-button"
              v-bind:class="{ loading: animate }"
            >
              <span class="button-text">{{ buttonText }}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import FormTitle from './FormTitle.vue';

export default {
  name: 'OnboardingForm',
  components: { FormTitle },
  props: [
    'errors',
    'formData',
    'formFields',
    'buttonText',
    'formTitleText',
    'formSubtext',
    'hintText',
    'baseLink',
    'toggle',
    'errorExists'
  ],
  data() {
    return {
      defErrors: '',
      disable: true,
      animate: '',
    };
  },
  watch: {
    toggle: function () {
      this.animate = false;
      this.$emit('toggleAnimation');
    },
  },
  methods: {
    // showPassword(field) {
    //   field.type = field.type === 'password' ? 'text' : 'password';
    // },
    handleChange(inputValue, inputName){
      const data = {
        name:inputName,
        value:inputValue
      };

      this.$emit('changeInput', data);
    },
    validateInputs(event, inputName) {
      const dataName = inputName;
      const inputValue = event.target.value.trim();

      switch(dataName){
        case 'emailAddress':
          this.validateEmail(inputValue);
          break;

        case 'password':
          this.validatePassword(inputValue);
          break;

        case 'confirmPassword':
          this.comparePassword(inputValue);
          break;

        case 'firstName':
          this.validateFirstName(inputValue);
          break;

        case 'phone':
          this.validatePhone(inputValue);
          break;

        case 'lastName':
          this.validateLastName(inputValue);
          break;

        case 'companyName':
          this.validateCompanyName(inputValue);
          break;

        case 'agencyName':
          this.validateAgencyName(inputValue);
          break;
      }

      this.handleChange(inputValue, dataName);

      if( this.formData.firstName === ''
          || this.formData.lastName === ''
          || this.formData.emailAddress === ''
          || this.formData.companyName === ''
          || this.formData.phone === ''
          || this.formData.password === ''
          || this.formData.confirmPassword === ''
          || this.defErrors.firstNameError === true
          || this.defErrors.lastNameError === true
          || this.defErrors.companyNameError === true
          || this.defErrors.agencyNameError === true
          || this.defErrors.emailError === true
          || this.defErrors.passwordError === true
          || this.defErrors.confirmPasswordError === true
          || this.defErrors.phoneError === true
      ){
        this.$emit('setErrorExists', true);
      } else {
        this.$emit('setErrorExists', false);
      }
    },
    validateEmail(email) {
      let checkPattern = new RegExp(/^[\w-.+]+@([\w-]+\.)+[\w-]{2,9}$/g);
      // let checkPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      let match = checkPattern.test(email);
      if (!match) {
        this.defErrors.emailError = true;
      } else {
        this.defErrors.emailError = false;
      }
    },
    validateFirstName(firstName) {
      let alphabetPattern = /^[A-Z-'a-z]+$/;
      let match = firstName.match(alphabetPattern);
      if (!match || firstName.trim() === '' || firstName.trim().length < 3) {
        this.defErrors.firstNameError = true;
      } else {
        this.defErrors.firstNameError = false;
      }
    },
    validateLastName(lastName) {
      let alphabetPattern = /^[A-Z-'a-z]+$/;
      let match = lastName.match(alphabetPattern);

      if (!match || lastName.trim() === '' || lastName.trim().length < 3) {
        this.defErrors.lastNameError = true;
      } else {
        this.defErrors.lastNameError = false;
      }
    },
    validateCompanyName(companyName) {
      if (companyName.trim() === '' || companyName.trim().length < 3) {
        this.defErrors.companyNameError = true;
      } else {
        this.defErrors.companyNameError = false;
      }
    },
    validateAgencyName(agencyName) {
      if (agencyName.trim() === '' || agencyName.trim().length < 3) {
        this.defErrors.agencyNameError = true;
      } else {
        this.defErrors.agencyNameError = false;
      }
    },
    validatePassword(password) {
      let passwordPattern = new RegExp('^(?=.*[a-z])(?=.*[0-9])(?=.{8,})');
      let match = passwordPattern.test(password);
      if (!match) {
        this.defErrors.passwordError = true;
      } else {
        this.defErrors.passwordError = false;
      }
    },
    comparePassword(confirmPassword) {
      let password = this.formData.password;
      if(password !== confirmPassword) {
        this.defErrors.confirmPasswordError = true;
      } else {
        this.defErrors.confirmPasswordError = false;
      }
    },
    validatePhone(number) {
      // let numberPattern = /^\d+$/;
      let numberPattern = /^\+?[0-9][0-9]{7,14}$/;

      // if (number.match(numberPattern) && (number.length > 8 && number.length < 15) ) {
      if (number.match(numberPattern)) {
        this.defErrors.phoneError = false;
      } else {
        this.defErrors.phoneError = true;
      }
    },
    handleSubmit(e) {
      e.preventDefault();

      let userData = this.formData;

      if (this.errorExists === false && this.errorExists !== '') {
        this.animate = true;
        this.$emit('userData', userData);
      } else {
        this.$emit('setErrorExists', true);

        if(this.formData.firstName === '') {
          this.defErrors.firstNameError = true;
        }
        if(this.formData.lastName === '') {
          this.defErrors.lastNameError = true;
        }
        if(this.formData.emailAddress === '') {
          this.defErrors.emailError = true;
        }
        if(this.formData.companyName === '') {
          this.defErrors.companyNameError = true;
        }
        if(this.formData.phone === '') {
          this.defErrors.phoneError = true;
        }
        if(this.formData.password === '') {
          this.defErrors.passwordError = true;
        }
        if(this.formData.confirmPassword === '') {
          this.defErrors.confirmPasswordError = true;
        }
      }
    }
  },
  mounted() {
    this.defErrors = {...this.errors};
  },
};
</script>
<style scoped>
  @keyframes buttonLoadingSpinner {
    from {
      transform: rotate(0turn);
    }
    to {
      transform: rotate(1turn);
    }
  }
  .loading::after {
    content: "";
    position: absolute;
    width: 1rem;
    height: 1rem;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    border: 4px solid transparent;
    border-top-color: var(--white);
    border-right-color: var(--white);
    border-radius: 50%;
    animation: buttonLoadingSpinner 1s linear infinite;
  }
  .form-container {
    padding: 6rem 2rem 2rem 2rem;
    width: 60%;
    justify-content: center;
    align-items: center;
  }
  a {
    text-decoration: none;
    color: var(--colorSecondary);
    font-family: 'montserrat';
  }
  .baselink-container {
    width: 100%;
    position: relative;
  }
  .baselink-container a {
    float: right;
    display: column;
  }
  .button-text {
    transition: all 0.2s;
  }
  .loading .button-text {
    visibility: hidden;
    opacity: 0;
  }
  .button-container .submit {
    background: var(--colorSecondary);
    color: var(--white);
    font-weight: bold;
    padding: 0.625rem 1.75rem;
    border: none;
    border-radius: 1.125rem;
    position: relative;
  }
  .admin-form {
    display: flex;
    align-items: center;
    padding-top: 6rem;
  }
  .form-field {
    margin: 1.875rem 0;
  }
  input[type="text"],
  input[type="email"],
  input[type="tel"],
  input[type="password"] {
    outline: none;
    font-size: 1.125rem;
    border: 0;
    border-bottom: 0.0625rem solid #e5e5e5;
    width: 100%;
    padding-bottom: 0.75rem;
  }
  /* .password-eye {
    position: absolute;
    cursor: pointer;
  } */
  .errorClass {
    background-color: #ffbaba;
    color: var(--white);
  }
  .passwordHintText {
    color: #787878;
    font-size: 0.575rem;
  }
  .errorExist {
    color: tomato;
    font-size: 12px;
  }
  .errorBlock {
    margin-bottom: 20px;
  }
  ::placeholder {
    color: #787878;
    font-size: 1.125rem;
  }
  .button-container {
    margin-top: 4rem;
  }
  .submit-button {
    color: var(--white);
    font-size: 1.25rem;
    background: var(--colorPrimary);
    border: none;
    outline: none;
    position: relative;
    padding: 20px;
    border-radius: 5px;
    width: 45%;
  }

  @media only screen and (min-width: 1200px) {
    .admin-form {
      padding-left: 4rem;
    }
    /* .password-eye {
      right: 20.313rem;
      bottom: 12.95rem;
    } */
  }
  @media (min-width: 991px) and (max-width: 1120px) {
    .form-container {
      width: 80%;
    }
  }
  /* @media only screen and (min-width: 991px) and (max-width: 1024px) {
    .password-eye {
      right: 9rem;
    }
  } */
  @media only screen and (max-width: 990px) {
    .admin-form {
      padding-top: 1.2rem;
      padding-left: 0;
    }
    .form-container {
      margin: 0 auto;
      padding: 6rem 2rem;
    }
    /* .password-eye {
      right: 13rem;
      bottom: 15.5rem;
    } */
  }

  @media only screen and (max-width: 767px) {
    .admin-form {
      justify-content: center;
      padding-left: 0;
    }
    .form-container {
      padding: 6rem 0;
    }
    input[type="text"],
    input[type="email"],
    input[type="tel"],
    input[type="password"] {
      width: 100%;
    }
    .baselink-container {
      width: 100%;
    }
    ::placeholder {
      color: #787878;
      font-size: 1.125rem;
    }
    .button-container {
      margin-top: 4rem;
    }
    .submit-button {
      width: 55%;
    }    
    /* .password-eye {
      right: 5rem;
      bottom: 14rem;
    } */
  }
  @media only screen and (max-width: 576px) {
    .submit-button {
      width: 60%;
    }    
    /* .password-eye {
      right: 7rem;
      bottom: 15.5rem;
    } */
  }
  @media only screen and (max-width: 420px) {
    .submit-button {
      width: 70%;
    }    
    /* .password-eye {
      right: 5rem;
      bottom: 15.5rem;
    } */
  }
  /* @media only screen and (max-width: 376px) {
    .password-eye {
      right: 5rem;
      bottom: 14rem;
    }
  } */
  /* @media only screen and (max-width: 361px) {
    .password-eye {
      right: 5rem;
      bottom: 15.5rem;
    }
  } */
</style>
